import { Layout } from "antd";
import React from "react";
import { useState, useEffect } from "react";
import { useParams } from "react-router";
import { NavLink } from "react-router-dom";
import AppFooter from "../Components/Footer"

const {Footer, Content} = Layout;

function Help() {
  const [token, settoken] = useState();

  const params = useParams();
  useEffect(() => {
    if (params.token) {
      settoken(params.token);
      console.log("params in help", params.token);
    }
  }, [params.token]);

  return (
    <Layout>
      <Content>
      <div className="flex justify-center items-center w-full h-screen">
        <div>
          <h1 className="text-center">GetStarted</h1>
          <NavLink to={"/welcome/" + token}>
            <button className="mt-10 bg-primary text-secondary px-4 py-2 rounded-lg h-full">
              Let's Start
            </button>
          </NavLink>
        </div>
      </div>

      </Content>
      
      <Footer> <AppFooter/> </Footer>
    </Layout>
  );
}
export default Help;
